/**
 * Import Dependency
 */

/**
 * Import API
 */
  
/**
 * Declare Variable
 */
const state = {
  layers: {},
  filterStatus: {
    displaymode: 'bouwjaarklasse'
  },
  highlighted: 0,

  // Whether the map is done loading
  loaded: false,

  // Edit Mode
  editMode: false,

  // The first map layer, from the bottom, containing labels. 
  // All additional layers are to be placed below this layer.
  symbolLayerId: null
  
}

const getters = {
  getFilterStatus: state => state.filterStatus,
  getHighlighted: state => state.highlighted,
  getLoadedStatus: state => state.loaded,
  getEditMode: state => state.editMode,
  getLayers: state => state.layers,
  getSymbolLayerId: state => state.symbolLayerId,

  getActiveLayerInfo: (state, getters, rootState) => rootState.filters.filters[state.filterStatus.displaymode]
}
const actions = {
 
}
const mutations = {

  /**
   * Pass an object with filterStatus
   *  If the state is recognised in the store it is saved
   * 
   * @param {*} state 
   * @param {{}}} filterStatus 
   */
  updateFilterStatus(state, filterStatus) {
    Object.keys(filterStatus).forEach(key => {
      if (state.filterStatus[key]) {
        state.filterStatus[key] = filterStatus[key]
      }
    })
  },
  setHighlighted(state, { pand_id }) {
    state.highlighted = pand_id
  },
  setLoadedStatus(state, { status }) {
    state.loaded = status
  },
  setEditMode(state, { enabled }) {
    state.editMode = !! enabled
  },
  setLayerAvailability(state, { layer, status }) {
    state.layers[layer] = !!status
  },
  setSymbolLayerId(state, { id }) {
    state.symbolLayerId = id
  }
}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
